export enum SortingKeyName {
  firstName = "first_name",
  lastName = "last_name",
  email = "email",
  updatedAt = "updated_at",
  certificateNumber = "certificate_number",
}

export enum SortingOrderKey {
  ASC = "asc",
  DESC = "desc",
}

export enum FilterStateStorageNames {
  PART_ONE = "partOne",
  PART_TWO = "partTwo",
  RENEWAL = "Renewal",
  STATE_TO_STATE = "StateToState",
  PEERS = "peers",
}

export interface TableSortEvent {
  apiUrl?: string | undefined;
  currentPage: number;
  filter?: string | undefined;
  perPage: number;
  sortBy: string;
  sortDesc: boolean;
}
